
const xsQuery = window.matchMedia('(max-width: 480px)') // Phone
const smQuery = window.matchMedia('(min-width: 481px) and (max-width: 768px)') // IPad Portrait, Phone Landscape
const mdQuery = window.matchMedia('(min-width: 769px) and (max-width: 1024px)') // IPad Landscape
const lgQuery = window.matchMedia('(min-width: 1025px) and (max-width: 1200px)') // Laptop, Desktop
const xlQuery = window.matchMedia('(min-width: 1201px)') // TV

export default class Breakpoints {
  // xs = null
  // xsQuery = window.matchMedia('(max-width: 480px)')
  // constructor () {
  // this.xsQuery.addEventListener('change', this.handleXsChange)
  // xsQuery.addListener(this.handleXsChange)
  // this.handleXsChange()
  // }

  get xs () {
    return xsQuery.matches
  }

  get sm () {
    return smQuery.matches
  }

  get md () {
    return mdQuery.matches
  }

  get lg () {
    return lgQuery.matches
  }

  get xl () {
    return xlQuery.matches
  }

  get smAndDown () {
    return this.sm || this.xs
  }

  get smAndUp () {
    return this.sm || this.md || this.lg || this.xl
  }

  get mdAndDown () {
    return this.md || this.sm || this.xs
  }

  get mdAndUp () {
    return this.md || this.lg || this.xl
  }

  get lgAndDown () {
    return this.lg || this.md || this.sm || this.xs
  }

  get lgAndUp () {
    return this.lg || this.xl
  }

  // handleXsChange () {
  // this.xs = xsQuery.matches
  // }
}
